import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';

import { RateYourExperienceComponent } from './rate-your-experience/rate-your-experience.component';
import { supportTicketsRoutingModule } from './support-tickets-routing.module';

@NgModule({
    declarations: [
        RateYourExperienceComponent,
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        supportTicketsRoutingModule,
        FormsModule,
    ]
})
export class SupportTicketsModule { }

